import React from 'react';

const SafetyComponent = () => {
  const safetyImage="https://jamaappprod.s3.ap-south-1.amazonaws.com/Website/maxwealthweb/Web-Images+compressed/Roots+and+Wings%2C+3lens+and+LSG/Saftey.png";
  return (
    <div className="bg-white">
      <div className="max-w-6xl w-full mx-auto px-4 sm:px-6 lg:px-8 py-4 md:py-6 lg:py-8">
        <div className="flex flex-col md:flex-row-reverse items-center gap-8">
          {/* Image side - now on the right */}
          <div className="w-full md:w-2/5">
            <img 
              src={safetyImage} 
              alt="Safety Portfolio" 
              className="rounded-lg w-full h-auto object-cover"
            />
          </div>
          
          {/* Content side */}
          <div className="w-full md:w-3/5">
            <h2 className="text-2xl md:text-3xl lg:text-4xl font-bold text-[#113262] mb-4">S: Safety – Stability Without Compromising Returns</h2>
            <h3 className="text-lg font-medium text-gray-800 mb-4">Capital Preservation with Moderate Growth</h3>
            
            <p className="text-gray-700 mb-4">
              Here, we focus on capital preservation. This portion of your portfolio is invested in high-quality debt instruments, conservative hybrid strategies, or capital-protected structures.
            </p>
            
            <h4 className="font-medium text-[#113262] mb-2">Key safety instruments we utilize:</h4>
            <ul className="mb-4 space-y-2">
              {[
                'High-grade corporate bonds with solid credit ratings',
                'Conservative hybrid funds with low equity exposure',
                'Tax-efficient debt strategies with optimal maturity profiles'
              ].map((item, index) => (
                <li key={index} className="flex items-start">
                  <svg className="h-5 w-5 text-gray-600 mt-0.5 flex-shrink-0" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                    <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M5 13l4 4L19 7" />
                  </svg>
                  <span className="ml-2 text-gray-700">{item}</span>
                </li>
              ))}
            </ul>
            
            <h4 className="font-medium text-[#113262] mb-2">Use case:</h4>
            <ul className="mb-4 space-y-2">
              {[
                'Planning to buy a house in the next 2–3 years?',
                'Need to fund your child\'s college education?',
                'Building a retirement corpus with predictable income'
              ].map((item, index) => (
                <li key={index} className="flex items-start">
                  <svg className="h-5 w-5 text-gray-600 mt-0.5 flex-shrink-0" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                    <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M5 13l4 4L19 7" />
                  </svg>
                  <span className="ml-2 text-gray-700">{item}</span>
                </li>
              ))}
            </ul>
            
            <p className="text-gray-700">
              This is the <span className="font-bold">safety net</span> that keeps your medium-term goals secure while providing returns that stay ahead of inflation.
            </p>
          </div>
        </div>
      </div>
    </div>
  );
};

export default SafetyComponent;